import { GroupIds } from "@/configuration/group-ids";
import { NIMBUS_PROVIDERS } from "@/configuration/groups/nimbus/providers";
import type { SchedulingCustomerConfig } from "@/customer-interface/scheduling";

/** Nimbus settings shared by the manifest and compatibility getters. */
export const nimbusSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: {
      VOICE: [GroupIds.NIMBUS_LIVE_SANDBOX],
      SMS: [GroupIds.NIMBUS_LIVE_SANDBOX],
    },
  },
  locationQuery: {
    enabledGroupIds: {
      VOICE: [GroupIds.NIMBUS_LIVE_SANDBOX],
      SMS: [GroupIds.NIMBUS_LIVE_SANDBOX],
    },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/nimbus/rules/schedule.yaml",
  },
  voice: {
    optionSearch: {
      progressiveChronologicalWindows: false,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: true,
    },
  },
  sms: {
    referralRegion: {
      regionId: "macon",
      // A real, empty region; an unmatched referral must not fall through to all locations.
      excludedRegionId: "excluded",
      providerNpis: [
        NIMBUS_PROVIDERS.DEAN.npi,
        NIMBUS_PROVIDERS.ROBINSON.npi,
        NIMBUS_PROVIDERS.HENDRICKS.npi,
        NIMBUS_PROVIDERS.PRITCHETT.npi,
        NIMBUS_PROVIDERS.FOREHAND.npi,
        NIMBUS_PROVIDERS.ROBBINS.npi,
        NIMBUS_PROVIDERS.COWART.npi,
      ],
      // Physical clinic (2) and Hendricks's tracking department at the same clinic (19).
      locationEhrIds: ["2", "19"],
    },
  },
} as const satisfies SchedulingCustomerConfig;
